module.exports = __webpack_public_path__ + "img/jzfs-j10bii_90.prt.e3fec43f.jpg";